// helpers/consignmentStatusHelper.js

export const getConsignmentStatusConfig = (status) => {
    const map = {
      reject: {
        label: "Reject",
        className: "cross-dim-2",
        circalClassName: "",
      },

      accept: {
        label: "Accept",
        className: "green-dim",
        circalClassName: "green",
      },
      
      pending: {
        label: "Pending",
        className: "orange-dim-2",
        circalClassName: "orange",
      },

      partial: {
        label: "Partial",
        className: "pink-dim",
        circalClassName: "pink",
      },
      unapproved: {
        label: "Unapproved",
        className: "blue-dim",
        circalClassName: "blue",
      },
      ordered: {
        label: "Ordered",
        className: "orange-dim-2",
        circalClassName: "orange",
      },
      other: {
        label: "Other",
        className: "orange-dim-2",
        circalClassName: "orange",
      },
    };
  
    return map[status] || {
      label: status,
      className: "",
      circalClassName:"red"
      
    };
  };

  export const getKitStatus = (kit, consignmentStatus) => {
    // if (kit.status !== undefined && kit.status !== null) {
    //   return kit.status === "accept" ? "accept" : "reject";
    // }
    if (kit.status !== undefined && kit.status !== null) {
      return kit.status;
    }

    // Old records fallback
    if (consignmentStatus === "reject") {
      return "reject";
    }

    // Ordered / Other are not reviewed yet, so their kits are still pending
    if (
      consignmentStatus === "pending" ||
      consignmentStatus === "ordered" ||
      consignmentStatus === "other"
    ) {
      return "pending";
    }

    if (consignmentStatus === "partial") {
      return "partial";
    }

    return "accept";
};